import React, { useEffect } from 'react'
import PropTypes from "prop-types";
import { TagEntities } from '../../api/services/next'
import EntityTypes from '../../pages/GroupReservation/Constants/EntityTypes'
import { useConfirmPopup } from '../../hooks/useConfirmPopup'
import { useTextResources, useMessageResources } from '../../language'
import { SystemTagsEnum } from '../shared/constants'
import { onError } from '../shared/messages';
import { PermissionsActions, UserHasPermission } from '../../components/shared/permissionsActions'

const FolioPendingPopup = ({ error, folioId, onCancel, onConfirm }) => {
    const { confirm } = useConfirmPopup();
    const text = useTextResources();
    const messages = useMessageResources();


    useEffect(() => {
        //validations:
        if (!error) return;

        if (UserHasPermission(PermissionsActions.AllowSetFolioAsPending)) {
            (async () => {
                if (error.ErrorCode == 12367) {
                    const guestTags = await CheckForTags(SystemTagsEnum.GuestPending);
                    const customerTags = await CheckForTags(SystemTagsEnum.CustomerPending);
                    await useConfirm([...guestTags, ...customerTags], [SystemTagsEnum.GuestPending, SystemTagsEnum.CustomerPending])
                }
                else if (error.ErrorCode == 10167) {
                    const tagEntities = await CheckForTags(SystemTagsEnum.GuestPending);
                    await useConfirm(tagEntities, [SystemTagsEnum.GuestPending])
                }
                else if (error.ErrorCode == 12354) {
                    const tagEntities = await CheckForTags(SystemTagsEnum.CustomerPending);
                    await useConfirm(tagEntities, [SystemTagsEnum.CustomerPending])
                }

            })();
        }
        else {
            onError(messages('NoPermissionsForThisAction'));
        }
    }, [error])


    const CheckForTags = async (tagId) => {
        var tagEntities = await TagEntities.GetFlatTagEntities({
            EntityId: folioId,
            EntityTypeId: EntityTypes.Folio,
            IsSystem: true,
            TagId: tagId
        });

        return tagEntities;
    }

    const useConfirm = async (tagEntities, tagIds) => {
        if (!tagEntities || tagEntities.length == 0) {
            await confirm({
                header: `${text('FolioNo')} ${folioId}`,
                content: text('FolioPending'),
                confirmButton: {
                    content: text('Yes'),
                    positive: true,
                },
                cancelButton: {
                    content: text('No'),
                    negative: true,
                },
                onConfirm: () => { addTagEntities(tagIds) },
                onCancel: onCancel
            });
        } else {
            onConfirm && onConfirm();
        }
    }

    const addTagEntities = async (tagIds) => {
        var tagEntities = [];
        tagIds.forEach(tagId => {
            tagEntities.push({
                EntityTypeId: EntityTypes.Folio,
                EntityId: folioId,
                TagId: tagId
            })
        });

        await TagEntities.CreateTagEntities(tagEntities);

        onConfirm && onConfirm();
    }

    return <div></div>
}


FolioPendingPopup.propTypes = {
    error: PropTypes.object,
    folioId: PropTypes.number,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func
}

export default FolioPendingPopup 